import React, { useRef, useState, useEffect } from 'react';

// Componente para dibujar la firma
const SignaturePad = ({ onSave }) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);

  const [canvasWidth, setCanvasWidth] = useState(850); // Ancho inicial del canvas
  const [canvasHeight, setCanvasHeight] = useState(200); // Alto inicial del canvas

  useEffect(() => {
    // Función para ajustar el tamaño del canvas cuando cambia el tamaño de la ventana
    const updateCanvasSize = () => {
      const width = window.innerWidth * 0.9; // 90% del ancho de la ventana
      const height = (width * 0.25); // Mantener relación de aspecto de 4:1 (ajustable)

      setCanvasWidth(width);
      setCanvasHeight(height);
    };

    // Llamamos a la función una vez para ajustar el tamaño inicial
    updateCanvasSize();

    // Agregamos un listener para cuando se redimensione la ventana
    window.addEventListener('resize', updateCanvasSize);

    // Limpiamos el listener cuando el componente se desmonte
    return () => {
      window.removeEventListener('resize', updateCanvasSize);
    };
  }, []);

  const startDrawing = (e) => {
    setIsDrawing(true);
    const ctx = canvasRef.current.getContext('2d');
    const rect = canvasRef.current.getBoundingClientRect();  // Obtenemos las coordenadas del canvas
    const offsetX = e.clientX - rect.left;
    const offsetY = e.clientY - rect.top;

    ctx.beginPath();
    ctx.moveTo(offsetX, offsetY);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const ctx = canvasRef.current.getContext('2d');
    const rect = canvasRef.current.getBoundingClientRect();  // Obtenemos las coordenadas del canvas
    const offsetX = e.clientX - rect.left;
    const offsetY = e.clientY - rect.top;

    // Ajustamos el grosor y color de la firma
    ctx.lineWidth = 4; // Grosor de la línea (puedes aumentarlo más)
    ctx.strokeStyle = '#000000'; // Color de la línea (negro)
    ctx.lineJoin = 'round';  // Estilo para que las líneas se unan de forma suave
    ctx.lineCap = 'round';  // Estilo para que las líneas terminen con bordes redondeados

    ctx.lineTo(offsetX, offsetY);
    ctx.stroke();
  };

  const stopDrawing = () => {
    setIsDrawing(false);
    const ctx = canvasRef.current.getContext('2d');
    ctx.closePath();
    const dataURL = canvasRef.current.toDataURL();
    onSave(dataURL);  // Pasamos la firma como imagen base64 al padre
  };

  const clearCanvas = () => {
    const ctx = canvasRef.current.getContext('2d');
    ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
  };

  // Funciones para manejar eventos táctiles (para dispositivos móviles)
  const startDrawingTouch = (e) => {
    e.preventDefault();  // Prevenir la acción predeterminada de tocar
    const touch = e.touches[0];  // Tomar el primer toque
    startDrawing(touch);
  };

  const drawTouch = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    draw(touch);
  };

  const stopDrawingTouch = () => {
    stopDrawing();
  };

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={canvasWidth} // Usamos el ancho calculado
        height={canvasHeight} // Usamos el alto calculado
        style={{ border: '1px solid #000', width: '100%', height: 'auto' }} // Ajuste de estilo responsivo
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={stopDrawing}
        onMouseOut={stopDrawing}
        // Soporte para eventos táctiles en dispositivos móviles
        onTouchStart={startDrawingTouch}
        onTouchMove={drawTouch}
        onTouchEnd={stopDrawingTouch}
      />
      <div style={{ marginTop: '10px' }}>
        <button onClick={clearCanvas}>Borrar</button>
      </div>
    </div>
  );
};

export default SignaturePad;
